import React from 'react';
import DashboardPage from './dashboard';


const ModelsPage: React.FC<any> = ({...res}) => {
  return (
    <DashboardPage {...res} />
  )
}
export default ModelsPage

export const Head: any = () => <title>Explore data models</title>